
const m = window.require("discourse/modifiers/trap-tab");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
